import { Image, Platform, StyleSheet, Text, View } from "react-native";

export default function Blank({ titleText, subtitleText, image }) {
  return (
    <View style={styles.container}>
      <Image
        source={
          image == 0
            ? require("../../assets/cage2.png")
            : require("../../assets/animation1.png")
        }
        style={{ marginTop: 20 }}
      />
      <View style={Platform.OS == "web" ? { width: "50%" } : { width: "70%" }}>
        <Text style={styles.titleText}>{titleText}</Text>
        <Text style={styles.subtitleText}>{subtitleText}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  titleText: {
    textAlign: "center",
    color: "#a48568",
    fontFamily: "quicksand-bold",
    fontSize: 20,
    marginTop: 20,
  },
  subtitleText: {
    textAlign: "center",
    color: "#56494C",
    fontSize: 15,
    fontFamily: "quicksand-bold",
    marginTop: 5,
  },
  imageStyle: {
    width: "20%",
    height: "100%",
  },
});
